// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"fd33cb0fe8f4e9efa38c","655":"048414d9a1f75283583f"}[chunkId] + ".js";
};